
























































import debounce from 'lodash.debounce'
import { Vue, Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import TheNotesDialog from '@/components/TheNotesDialog.vue'
import { ICourseLessonData } from '../../types'


@Component({ 
  components: { TheNotesDialog }
})
export default class NotesPage extends Vue {

  @Action('openNotesDialog', { namespace: 'app' }) openNotesDialog!: (notesId: string) => Promise<void>

  @Action('startLoading', { namespace: 'system' }) startLoading!: () => void
  @Action('stopLoading', { namespace: 'system' }) stopLoading!: () => void
  @Getter('loading', { namespace: 'system' }) loading!: boolean
  
  @Getter('lessonsSorted', { namespace: 'courses' }) lessonsSorted!: (id: string) => ICourseLessonData[]
  @Action('loadObject', { namespace: 'courses' }) loadCourse!: (courseId: string) => Promise<boolean>
  
  @Action('loadObject', { namespace: 'notes' }) loadNotes!: (lessonId: string) => Promise<boolean>
  @Getter('notes', { namespace: 'notes' }) notes!: (id: string) => string


  // ! make dynamic
  courseId = 'ef637349-6907-4963-a393-79d140ba008f'

  created() {
    this.init()
  }

  activated() {
    this.init()
  }

  async init() {
    await this.startLoading()
    await this.load()
    await this.stopLoading()
  }

  get courses() {
    return [{
      id: this.courseId,
      title: 'Werkgeluk',
      lessons: this.lessonsSorted(this.courseId)
        .map(l => {
          return {
            id: l.id,
            title: l.title,
            notes: this.notes(l.id)
          }
        })
    }]
  }

  get lessonsWithNotes() {
    return (courseId: string) => {
      const course = this.courses.find(c => c.id === courseId)
      return !course ? [] : course.lessons
        .filter(l => this.notes(l.id) && this.notes(l.id).length > 0)
    }
  }

  async load() {
    await this.loadCourse(this.courseId)

    // * load all notes
    await Promise.all(
      this.lessonsSorted(this.courseId).map(async lesson => {
        return await this.loadNotes(lesson.id)
      })
    )
  }
 

  //     // * load lesson data
  //     const path = `/content/${this.preferredDomain}-${this.preferredVersion}/lessons/${id}`
  //     const response = await read(Database.FIRESTORE, { path })
  //     this.data = response.data! as ILessonData
  //     this.setTitle({ thin: 'Les', regular: this.data.title })

}
